import { useQuery } from "@tanstack/react-query";
import { Empty, Flex, Radio, Typography } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { getSchemas } from "../actions/acc_actions";
import InsightsForm from "../components/InsightsForm";
import InsightsSummary from "../components/InsightsSummary";
import ContentLayout from "../components/layout/ContentLayout";

const { Title, Text } = Typography;

export default function Insights() {
  const { t } = useTranslation();

  const businessUrn = useSelector((state) => state.account.businessUrn);

  const [selectedSchema, setSelectedSchema] = useState(null);

  const { isLoading, data } = useQuery({
    queryKey: ["schemas", businessUrn],
    queryFn: () => getSchemas(businessUrn, "STAMP_CARD"),
    enabled: Boolean(businessUrn),
  });

  const schemas = useMemo(() => {
    return data?.data?.body ?? [];
  }, [data]);

  useEffect(() => {
    if (!schemas.length) {
      setSelectedSchema(null);
      return;
    }

    setSelectedSchema((current) => {
      // keep current selection if it still exists
      if (current && schemas.some((s) => s.slug === current)) {
        return current;
      }

      // otherwise select first schema
      return schemas[0].slug;
    });
  }, [schemas]);

  const noSchemas = !isLoading && schemas.length === 0;

  console.log({
    selectedSchema,
    schemas,
    selectedExists: schemas.some((s) => s.slug === selectedSchema),
  });

  return (
    <ContentLayout
      header={
        <Flex vertical gap={20}>
          <div>
            <Title level={2} style={{ marginBottom: 0 }}>
              {t("welcome_to")}
            </Title>

            <Text type="secondary" style={{ fontSize: 18 }}>
              {t("your_stamp_card_dashboard")}
            </Text>
          </div>

          {!noSchemas && schemas.length > 0 && (
            <Flex align="center" gap={16} wrap="wrap">
              <Text strong>{t("your_insights_for")}:</Text>

              <Radio.Group
                value={selectedSchema}
                onChange={(e) => setSelectedSchema(e.target.value)}
                optionType="button"
                buttonStyle="solid"
              >
                {schemas.map((schema) => (
                  <Radio.Button key={schema.slug} value={schema.slug}>
                    {schema.name}
                  </Radio.Button>
                ))}
              </Radio.Group>
            </Flex>
          )}

          {!noSchemas && selectedSchema && (
            <InsightsSummary selectedSchema={selectedSchema} />
          )}
        </Flex>
      }
    >
      <div className="insights">
        {noSchemas ? (
          <Empty description={t("you_must_create_stampcard_first")} />
        ) : (
          <>
            <h2 className="active">{t("find_out_more_about_scheme")}</h2>

            <h5>{t("select_dates_to_track_performance")}</h5>

            {selectedSchema && <InsightsForm selectedSchema={selectedSchema} />}
          </>
        )}
      </div>
    </ContentLayout>
  );
}
